import React from "react";
import { TableCell, TableRow } from "@material-ui/core";
import pretty from "Shared/pretty";
import { DPPayrollAnomalyOutlier } from "Shared/types/PayrollAnomaly";

export interface EmployeeAnomalyRowProps {
  anomaly: DPPayrollAnomalyOutlier;
}

export const EmployeeAnomalyRow = ({ anomaly }: EmployeeAnomalyRowProps) => {
  const { firstName, lastName, externalId, netPay, netPayMean, deviationFromMean } = anomaly;

  function formatStatAmount(amount: number) {
    return pretty.dollar(Math.round(amount * 100));
  }

  return (
    <TableRow>
      <TableCell>{pretty.fullName(firstName || "", lastName || "")}</TableCell>
      <TableCell>{externalId}</TableCell>
      <TableCell>{formatStatAmount(netPay)}</TableCell>
      <TableCell>{formatStatAmount(netPayMean)}</TableCell>
      <TableCell>{formatStatAmount(deviationFromMean)}</TableCell>
    </TableRow>
  );
};

